import API from './ApiBase';
import type {
  GetNotificationsRequest,
  GetNotificationsResponse,
  NotificationPreferencesPayload
} from '../types/Notification.types';

export const notificationService = {
  async getNotifications({
    page = 1,
    limit = 10
  }: Partial<GetNotificationsRequest> = {}): Promise<GetNotificationsResponse> {
    try {
      const response = await API.request<GetNotificationsResponse>({
        url: '/notifications',
        method: 'GET',
        params: { page, limit }
      });
      return response.data;
    } catch (error: any) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Failed to fetch notifications. Please try again.');
    }
  },

  async markNotificationAsRead(id: string): Promise<void> {
    try {
      await API.patch(`/notifications/${id}/read`);
    } catch (error: any) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Failed to mark notification as read. Please try again.');
    }
  },

  async markAllNotificationsAsRead(): Promise<void> {
    try {
      await API.patch('/notifications/read-all');
    } catch (error: any) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Failed to mark all notifications as read. Please try again.');
    }
  },

  async getNotificationPreferences(): Promise<NotificationPreferencesPayload> {
    try {
      const response = await API.get<NotificationPreferencesPayload>('/notifications/preferences/types');
      return response.data;
    } catch (error: any) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Failed to fetch notification preferences. Please try again.');
    }
  },

  async updateNotificationPreferences(preferences: NotificationPreferencesPayload): Promise<void> {
    try {
      await API.patch('/notifications/preferences/types', preferences);
    } catch (error: any) {
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error('Failed to update notification preferences. Please try again.');
    }
  },
};

